module.exports = __webpack_public_path__ + "img/feature-3.fa27cf6c.jpg";